/** Allineato a backend PurchaseOrderLine.Status (apiv1/models/purchase_orders.py) */
export const PurchaseOrderLineStatus = {
  IN_ARRIVO: 1,
  COMPLETED: 2,
  CANCELED: 3,
  AWAITING_CONFIRMATION: 4
} as const;
/** Valore querystring per filtri API (righe ricevibili, ex PENDING). */

export const PURCHASE_ORDER_LINE_STATUS_FILTER_IN_ARRIVO = String(
  PurchaseOrderLineStatus.IN_ARRIVO
);

export const PURCHASE_ORDER_LINE_STATUS_FILTER_AWAITING_CONFIRMATION = String(
  PurchaseOrderLineStatus.AWAITING_CONFIRMATION
);

export const ORDER_LINE_STATUS_TABS = {
  IN_ARRIVO: 'in-arrivo',
  AWAITING_CONFIRMATION: 'awaiting-confirmation'
} as const;

export type OrderLineStatusTab = typeof ORDER_LINE_STATUS_TABS[keyof typeof ORDER_LINE_STATUS_TABS];

export function normalizeOrderLineStatusTab(tab: string | null): OrderLineStatusTab {
  if (tab === ORDER_LINE_STATUS_TABS.AWAITING_CONFIRMATION) {
    return ORDER_LINE_STATUS_TABS.AWAITING_CONFIRMATION;
  }
  return ORDER_LINE_STATUS_TABS.IN_ARRIVO;
}

export function orderLineStatusFilterForTab(tab: string | null): string {
  if (normalizeOrderLineStatusTab(tab) === ORDER_LINE_STATUS_TABS.AWAITING_CONFIRMATION) {
    return PURCHASE_ORDER_LINE_STATUS_FILTER_AWAITING_CONFIRMATION;
  }
  return PURCHASE_ORDER_LINE_STATUS_FILTER_IN_ARRIVO;
}
const STATUS_I18N_KEYS: Record<string, string> = {
  '1': 'IN_ARRIVO',
  '2': 'COMPLETED',
  '3': 'CANCELED',
  '4': 'AWAITING_CONFIRMATION',
  PENDING: 'IN_ARRIVO',
  IN_ARRIVO: 'IN_ARRIVO',
  'In arrivo': 'IN_ARRIVO',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  AWAITING_CONFIRMATION: 'AWAITING_CONFIRMATION',
  'In attesa conferma': 'AWAITING_CONFIRMATION'
};

export function orderLineStatusI18nKey(status: string | number | null | undefined): string {
  if (status === null || status === undefined || status === '') {
    return '';
  }
  const key = STATUS_I18N_KEYS[String(status)];
  return key ? `entities.order_line.${key}` : `entities.order_line.${status}`;
}

export function translateOrderLineStatus(
  t: (key: string) => string,
  status: string | number | null | undefined
): string {
  const i18nKey = orderLineStatusI18nKey(status);
  if (!i18nKey) {
    return '';
  }
  const translated = t(i18nKey);
  return translated !== i18nKey ? translated : String(status);
}

export function orderLineStatusColor(status: string | number | null | undefined): string {
  const key = STATUS_I18N_KEYS[String(status ?? '')] ?? String(status);
  switch (key) {
    case 'IN_ARRIVO':
    case 'PENDING':
      return 'text-orange-500';
    case 'AWAITING_CONFIRMATION':
      return 'text-amber-600';
    case 'COMPLETED':
      return 'text-green-500';
    case 'CANCELED':
      return 'text-red-500';
    case 'NEW':
      return 'text-yellow-500';
    default:
      return 'text-gray-500';
  }
}

export const ORDER_LINE_STATUS_FILTER_OPTIONS = [
  {
    value: String(PurchaseOrderLineStatus.IN_ARRIVO),
    i18nKey: 'IN_ARRIVO'
  },
  {
    value: String(PurchaseOrderLineStatus.AWAITING_CONFIRMATION),
    i18nKey: 'AWAITING_CONFIRMATION'
  },
  {
    value: String(PurchaseOrderLineStatus.COMPLETED),
    i18nKey: 'COMPLETED'
  },
  {
    value: String(PurchaseOrderLineStatus.CANCELED),
    i18nKey: 'CANCELED'
  }
] as const;
